import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import manifest from "../assets/images/portfolio/manifest.svg";
import desginfirm from "../assets/images/portfolio/designFirms.svg";
import googlereview from "../assets/images/portfolio/google.svg";
import clutch from "../assets/images/portfolio/Clutch.svg";
import linkedin from "../assets/images/social/skill-icons_linkedin.svg";
import facebook from "../assets/images/social/logos_facebook.svg";
import instagram from "../assets/images/social/skill-icons_instagram.svg";
import twitter from "../assets/images/social/fa6-brands_square-x-twitter.svg";
import pinterst from "../assets/images/social/logos_pinterest.svg";
import tick from "../assets/images/Shapes/tick.svg";
import support from "../assets/images/Shapes/support.svg";

const Contacts = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    helpType: "Project Discussion",
    service: "Web Design",
    company: "",
    message: "",
  });
  const [checked, setChecked] = useState(false);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); // New state for loading
  const jsForm = useRef();

  const updateFormData = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading to true when submission starts

    // Validate form inputs
    if (!checked) {
      setMessage("Please accept our terms & conditions!");
      setIsLoading(false); // Stop loading
      setTimeout(() => setMessage(""), 5000);
      return;
    }

    if (
      !form.name ||
      !form.email ||
      !form.email.includes("@") ||
      !form.email.includes(".") ||
      !form.helpType ||
      !form.service ||
      !form.company ||
      !form.message
    ) {
      setMessage("Please fill in all fields correctly!");
      setIsLoading(false); // Stop loading
      setTimeout(() => setMessage(""), 5000);
      return;
    }

    emailjs
      .sendForm(
        "service_5zf2ywi",
        "template_hqkompe",
        jsForm.current,
        "QhQMFueRd5IbBP3MZ"
      )
      .then(
        (result) => {
          console.log(result.text);
          setMessage("Message sent successfully!");
          setForm({
            name: "",
            email: "",
            helpType: "Project Discussion",
            service: "Web Design",
            company: "",
            message: "",
          });
          setChecked(false);
          setIsLoading(false); // Stop loading
          setTimeout(() => setMessage(""), 5000);
        },
        (error) => {
          console.log(error.text);
          setMessage("Failed to send message. Please try again.");
          setIsLoading(false); // Stop loading
          setTimeout(() => setMessage(""), 5000);
        }
      );
  };

  return (
    <>
      <section className="px-6 mt-16 bg-white lg:px-16">
        <div className="flex flex-col gap-4 lg:gap-16 lg:flex-row">
          <div className="flex-1">
            <p className="text-[10px] md:text-sm text-black flex justify-center items-center font-bold">
              Home /{" "}
              <span className="text-white bg-[#7c44af] px-2 py-1 rounded text-[10px] md:text-sm ml-2">
                Contacts
              </span>
            </p>
            <div className="flex justify-center gap-2 lg:justify-end lg:gap-6">
              <h1 className="mt-0 text-2xl font-extrabold uppercase lg:text-right md:text-4xl xl:text-6xl lg:mt-2 multi_color_heading">
                Get in touch
              </h1>
            </div>
            <h2 className="mt-2 text-base font-light text-center text-black uppercase md:text-xl lg:text-right lg:text-2xl">
              Thank you for your interest in Webybuild and Our Services, We will
              get back to you within 24 hrs
            </h2>
          </div>
          <div className="flex items-center justify-center flex-1">
            <div className="flex justify-center gap-1 lg:gap-4 mt-7 lg:justify-start lg:mb-8 xl:mb-0">
              <img className="w-[30%] lg:w-[21%]" src={googlereview} alt="" />
              <img className="w-[20%] lg:w-[15%]" src={desginfirm} alt="" />
              <img
                className="w-[25%] lg:w-[18%] ml-3 lg:ml-5"
                src={manifest}
                alt=""
              />
              <img
                className="w-[15%] lg:w-[13%] ml-1 lg:ml-4"
                src={clutch}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col-reverse justify-center px-0 mt-12 lg:flex-row lg:px-9">
          <div className="flex-1">
            <div className="mt-16 mb-4">
              <h1 className="text-2xl font-bold text-center lg:text-left md:text-3xl lg:text-5xl">
                Reach Out to Us
              </h1>
              <h1 className="mt-3 text-sm text-center text-gray-400 md:text-base lg:text-left">
                We're just a message away, and we'll be sure to reply to you
                within 24 hours
              </h1>
            </div>
            <hr className="w-full border-t border-gray-300 lg:w-1/2" />
            <div className="my-8">
              <h1 className="font-bold text-center lg:text-left">
                Nations Where We Provide Our Services
              </h1>
              <div className="m-4">
                <div className="flex items-center justify-center gap-2 lg:justify-start">
                  <img className="w-[5%]" src={tick} alt="" />
                  <h1 className="font-light">USA</h1>
                </div>
                <div className="flex items-center justify-center gap-2 lg:justify-start">
                  <img className="w-[5%]" src={tick} alt="" />
                  <h1 className="font-light">Canada</h1>
                </div>
                <div className="flex items-center justify-center gap-2 lg:justify-start">
                  <img className="w-[5%]" src={tick} alt="" />
                  <h1 className="font-light">Germany</h1>
                </div>
                <div className="flex items-center justify-center gap-2 lg:justify-start">
                  <img className="w-[5%]" src={tick} alt="" />
                  <h1 className="font-light">Australia</h1>
                </div>
                <div className="flex items-center justify-center gap-2 lg:justify-start">
                  <img className="w-[5%]" src={tick} alt="" />
                  <h1 className="font-light">Switzerland</h1>
                </div>
                <div className="flex items-center justify-center gap-2 lg:justify-start">
                  <img className="w-[5%]" src={tick} alt="" />
                  <h1 className="font-light">Ireland</h1>
                </div>
              </div>
            </div>
            <hr className="w-full my-4 border-t border-gray-300 lg:w-1/2" />
            <div className="my-4">
              <h1 className="my-2 font-bold text-center lg:text-left">
                Support
              </h1>
              <div className="flex items-center justify-center gap-2 lg:justify-start">
                <img className="w-[5%]" src={support} alt="" />
                <h1 className="text-gray-500">hello@webybuild.com</h1>
              </div>
            </div>
            <div className="mt-16">
              <h1 className="my-4 font-bold text-center lg:text-left">
                Follow Us
              </h1>
              <div className="flex items-center justify-center gap-3 lg:justify-start">
                <a
                  href="https://www.linkedin.com/in/harsh-j-b509b4172/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedin} alt="LinkedIn" />
                </a>
                <a
                  href="https://twitter.com/WEBYBUILD"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twitter} alt="Twitter" />
                </a>
                <a
                  href="https://www.facebook.com/webybuild"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={facebook} alt="Facebook" />
                </a>
                <a
                  href="https://in.pinterest.com/webybuild/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={pinterst} alt="Pinterest" />
                </a>
                <a
                  href="https://www.instagram.com/webybuild/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagram} alt="Instagram" />
                </a>
              </div>
            </div>
          </div>
          <div className="flex-1 py-8 lg:py-16 px-4 lg:px-12 mx-auto max-w-screen-md bg-[#f9f9f9] rounded-3xl">
            <h2 className="mb-4 text-2xl font-extrabold tracking-tight text-center text-gray-900 lg:text-4xl">
              Contact Us
            </h2>
            <p className="mb-8 text-xs font-light text-center text-gray-500 md:text-sm lg:text-lg lg:mb-16 dark:text-gray-400">
              Got a technical issue? Want to send feedback about our service?
              Need details about our Business plan? Let us know.
            </p>
            <form
              id="contact-form"
              action="#"
              ref={jsForm}
              onSubmit={sendEmail}
              className="space-y-8"
            >
              <div className="flex w-full gap-8">
                <div className="w-full">
                  <label
                    htmlFor="name"
                    className="block mb-2 text-xs md:text-sm font-medium text-[#818181]"
                  >
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="block w-full p-3 text-xs text-gray-900 bg-white rounded-lg shadow-lg md:text-sm focus:ring-primary-500 focus:border-primary-500"
                    placeholder="John Doe"
                    required
                    value={form.name}
                    onChange={(e) => updateFormData(e)}
                  />
                </div>
                <div className="w-full">
                  <label
                    htmlFor="email"
                    className="block mb-2 text-xs md:text-sm font-medium text-[#818181]"
                  >
                    Your email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="block w-full p-3 text-xs text-gray-900 bg-white border rounded-lg shadow-lg md:text-sm focus:ring-primary-500 focus:border-primary-500"
                    placeholder="name@email.com"
                    required
                    name="email"
                    value={form.email}
                    onChange={(e) => updateFormData(e)}
                  />
                </div>
              </div>
              <div className="flex w-full gap-8">
                <div className="w-full">
                  <label
                    htmlFor="help"
                    className="block mb-2 text-xs md:text-sm font-medium text-[#818181]"
                  >
                    How we can assist?
                  </label>
                  <div className="flex items-center">
                    <select
                      name="helpType"
                      id="Project_menu"
                      onChange={(e) => updateFormData(e)}
                      className="block w-full p-3 text-xs text-gray-900 bg-white border rounded-lg shadow-lg md:text-sm focus:ring-primary-500 focus:border-primary-500"
                      value={form.helpType}
                    >
                      <option value="Project Discussion">
                        Project Discussion
                      </option>
                      <option value="General Question">General Question</option>
                      <option value="Complain">Complain</option>
                      <option value="Feedback">Feedback</option>
                      <option value="Job / Career">Job / Career</option>
                      <option value="Legal">Legal</option>
                    </select>
                  </div>
                </div>
                <div className="w-full">
                  <label
                    htmlFor="help"
                    className="block mb-2 text-xs md:text-sm font-medium text-[#818181]"
                  >
                    Services?
                  </label>
                  <div className="flex items-center">
                    <select
                      name="service"
                      id="Project_menu"
                      onChange={(e) => updateFormData(e)}
                      className="block w-full p-3 text-xs text-gray-900 bg-white border rounded-lg shadow-lg md:text-sm focus:ring-primary-500 focus:border-primary-500"
                      value={form.service}
                    >
                      <option value="Web Design">Web Design</option>
                      <option value="Web Development">Web Development</option>
                      <option value="Inventory Management">
                        Inventory Management
                      </option>
                      <option value="Mobile Application">
                        Mobile Application
                      </option>
                      <option value="Cloud Services">Cloud Services</option>
                      <option value="Logo Design">Logo Design</option>
                      <option value="Digital Marketing">
                        Digital Marketing
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <label
                  htmlFor="subject"
                  className="block mb-2 text-xs md:text-sm font-medium text-[#818181]"
                >
                  Company / Organization
                </label>
                <input
                  type="text"
                  id="subject"
                  className="block w-full p-3 text-xs text-gray-900 bg-white border rounded-lg shadow-lg md:text-sm focus:ring-primary-500 focus:border-primary-500"
                  placeholder="Enter the name of your company or brand"
                  required
                  name="company"
                  value={form.company}
                  onChange={(e) => updateFormData(e)}
                />
              </div>
              <div className="sm:col-span-2">
                <label
                  htmlFor="message"
                  className="block mb-2 text-xs md:text-sm font-medium text-[#818181]"
                >
                  Your message
                </label>
                <textarea
                  id="message"
                  rows="6"
                  className="block p-2.5 w-full text-xs md:text-sm text-gray-900 bg-white rounded-lg shadow-lg focus:ring-primary-500 focus:border-primary-500"
                  placeholder="Leave a comment..."
                  required
                  name="message"
                  value={form.message}
                  onChange={(e) => updateFormData(e)}
                ></textarea>
              </div>
              <div className="">
                <div className="flex items-center gap-6">
                  <input
                    type="checkbox"
                    id="terms"
                    className="w-5 h-5 border-2 rounded-md form-checkbox text-primary-500 border-primary-500 focus:ring-2 ring-primary-500 focus:ring-offset-0 dark:text-primary-500 dark:focus:ring-primary-500 dark:ring-offset-0"
                    required
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                  />
                  <label
                    htmlFor="terms"
                    className="block text-sm font-medium text-[#686868]"
                  >
                    I agree with{" "}
                    <a
                      href="/terms-and-conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#ab5a91]"
                    >
                      Terms & Conditions
                    </a>
                  </label>
                </div>
                <p className="mt-5 text-xs text-center lg:text-left">
                  We will not spam or bother you, we may contact you for any
                  further questions.
                </p>
              </div>
              <div
                aria-live="polite"
                className={`text-center text-sm ${
                  message.includes("successfully")
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {message}
              </div>
              <div className="items-center justify-center space-y-3 gap-x-3 sm:flex sm:space-y-0">
                <button
                  type="submit"
                  className="relative block px-4 py-2 font-medium text-center text-black border cursor-pointer gradient-border-button hover:shadow-lg lg:text-left"
                  disabled={isLoading} // Disable button during loading
                >
                  <span className={isLoading ? "opacity-0" : "opacity-100"}>
                    Send Message
                  </span>
                  {isLoading && (
                    <span className="absolute inset-0 flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-black animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contacts;
